import React, { Component } from "react";

// SCSS
import "./ShoveberryLevelsLayoutControlPanelResponsive.scss";

// Icons & Images
import UndoIcon from "static/assets/shoveberry/images/undo-icon.png";
import ResetIcon from "static/assets/shoveberry/images/reset-icon.png";
import WhiteMusicIcon from "static/assets/shoveberry/images/white-music-icon.svg";
import MoveUpArrowIcon from "static/assets/shoveberry/images/move-up-arrow-icon.png";
import MoveDownArrowIcon from "static/assets/shoveberry/images/move-down-arrow-icon.png";
import MoveLeftArrowIcon from "static/assets/shoveberry/images/move-left-arrow-icon.png";
import MoveRightArrowIcon from "static/assets/shoveberry/images/move-right-arrow-icon.png";

class ShoveberryLevelsLayoutControlPanelResponsive extends Component {
  render() {
    const {
      onUndo,
      onReset,
      onMusicClicked,
      onMoveUp,
      onMoveDown,
      onMoveLeft,
      onMoveRight,
      showOnlyMoves = false,
    } = this.props;

    return (
      <div className="shoveberry-levels-responsive-main">
      {/* <> */}
        <div
          className={`shoveberry-levels-layout-control-panel-responsive ${
            showOnlyMoves ? "no-shadow" : ""
          }`}
        >
          {/* Undo Button */}
          {!showOnlyMoves && (
            <img
              src={UndoIcon}
              alt="Undo Icon"
              className="shoveberry-levels-layout-control-panel-responsive__undo-icon"
              onClick={() => onUndo()}
            />
          )}

          {/* Moves Container */}
          <div className="shoveberry-levels-layout-control-panel-responsive__moves-container">
            <div className="shoveberry-levels-layout-control-panel-responsive__moves-container--top-section">
              <img
                src={MoveUpArrowIcon}
                alt="Move up icon"
                onClick={() => onMoveUp()}
              />
            </div>
            <div className="shoveberry-levels-layout-control-panel-responsive__moves-container--bottom-section">
              <img
                src={MoveLeftArrowIcon}
                alt="Move left icon"
                onClick={() => onMoveLeft()}
              />
              <img
                src={MoveDownArrowIcon}
                alt="Move down icon"
                onClick={() => onMoveDown()}
              />
              <img
                src={MoveRightArrowIcon}
                alt="Move right icon"
                onClick={() => onMoveRight()}
              />
            </div>
          </div>

          {!showOnlyMoves && (
            <>
              {/* Reset Icon */}
              <img
                src={ResetIcon}
                alt="Reset Icon"
                className="shoveberry-levels-layout-control-panel-responsive__reset-icon"
                onClick={() => onReset()}
              />

              {/* Music Icon */}
              {/* <img
                src={WhiteMusicIcon}
                alt="Music Icon"
                className="shoveberry-levels-layout-control-panel-responsive__music-icon"
                onClick={() => onMusicClicked()}
              /> */}
            </>
          )}
        </div>

        <div className="shoveberry-levels-responsive-main__text-container">
          <p>Use above buttons or your keyboard arrow commands to move.</p>
        </div>
      </div>
      // {/* </> */}
    );
  }
}
export default ShoveberryLevelsLayoutControlPanelResponsive;
